import React, { useState } from 'react';

import { Button, Modal } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import CloseableModal from 'components/common/CloseableModal';
import WebsiteComponentInteractionWidget from 'components/modules/website-component-interaction/components/WebsiteComponentInteractionWidget';
import { INTERACTION_STYLE_PRIMARY } from 'components/modules/website-component-interaction/constants';
import { objectToCamelCase, objectToSnakeCase } from 'libs/format';

import { generateButtonMarkdown } from './MarkdownButtonPlugin.utils';

import './MarkdownButtonPlugin.scss';

export default function MarkdownButtonPlugin() {
  const INITIAL_INTERACTION_DATA = {
    enabled: true,
    style: INTERACTION_STYLE_PRIMARY,
    url: '',
  };

  const [open, setOpen] = useState(false);
  const [editor, setEditor] = useState(null);
  const [interaction, setInteraction] = useState({ ...INITIAL_INTERACTION_DATA });

  function openModal() {
    setOpen(true);
  }

  function closeModal() {
    setOpen(false);
  }

  function resetInteraction() {
    setInteraction({ ...INITIAL_INTERACTION_DATA });
  }

  function insertMarkdownButton(codemirror) {
    const markdown = generateButtonMarkdown(interaction);
    const pos = codemirror.getCursor();
    codemirror.setSelection(pos, pos);
    codemirror.replaceSelection(markdown);
    resetInteraction();
    closeModal();
  }

  function onSubmit() {
    const { codemirror } = editor;

    if (!codemirror) {
      return;
    }

    insertMarkdownButton(codemirror);
  }

  function onInteractionChange(changes) {
    setInteraction((prevInteraction) => objectToCamelCase({ ...prevInteraction, ...changes }));
  }

  function isFormValid() {
    const { url, style, label } = interaction || {};
    return !_isEmpty(url) && !_isEmpty(style) && !_isEmpty(label);
  }

  const pluginButton = {
    name: 'button',
    title: 'Button',
    className: 'fa fa-plus-square',
    action: (instance) => {
      setEditor(instance);
      openModal();
    },
  };

  const ButtonConfigurationModal = (
    <CloseableModal
      key="button"
      open={open}
      onClose={closeModal}
      header="Add Button"
      className="markdown-button-plugin"
      onOpen={resetInteraction}
      size="small"
    >
      <Modal.Content>
        <WebsiteComponentInteractionWidget
          title="Button"
          websiteComponentInteraction={objectToSnakeCase(interaction)}
          onChange={onInteractionChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          className="secondary-navy"
          onClick={onSubmit}
          disabled={!isFormValid()}
          content="Add"
        />
      </Modal.Actions>
    </CloseableModal>
  );

  return [ButtonConfigurationModal, pluginButton];
}
